/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import React from "react";

export class TextAreaViewer extends BaseFieldViewer {
	@autobind
	_render() {
		const {Value} = this.props;

		return Value != null ? <span className="pndlm-line-break">{Value}</span> : "";
	}
}